module.exports = __webpack_public_path__ + "img/tariff-selection-bg--767.cb3338d.jpg";